import Phaser, { RIGHT } from "phaser";


export default class Enemy extends Phaser.Physics.Arcade.Sprite
{
    constructor(scene,x,y,texture){
        super(scene,x,y,texture)
        this.setScale(0.25)
        this.speed = 100 
        this.orientation = undefined


    }
    
    spawn(x,y)
    {
        this.setPosition(x,y)
        this.setActive(true)
        this.setVisible(true)
    }
    erase()
    {
        this.destroy()
    }

    update(time)
    {
        if(this.x<=1600){
            this.speed = this.speed * -1 
            this.setFlipX(false)
        }
        if(this.x>=1800) {
        this.speed = -1*this.speed
            this.setFlipX(true)}
        this.setVelocityX(this.speed)


    //this.setVelocityX(this.speed)
}
    
}